import { baseModule } from '@/container-modules/base-module';
import { headerServiceModule } from '@/container-modules/header-service-module';
import { agentContainer } from '@/domains/agent';
import { aiSearchContainer } from '@/domains/ai-search';
import { companyContainer } from '@/domains/company';
import { chatContainer } from '@/domains/company-search';
import { homeContainer } from '@/domains/home';
import { ipServiceContainer } from '@/domains/ip';
import { materialContainer } from '@/domains/material';
import { monitorSuggestContainer } from '@/domains/monitor-suggest';
import { onboardingContainer } from '@/domains/onboarding';
import { projectContainer } from '@/domains/project';
import { roadmapContainer } from '@/domains/roadmap';
import { searchResultContainer } from '@/domains/search-result';
import { seekContainer } from '@/domains/seek';
import { sharedContainer } from '@/domains/shared';
import { biTrackModule } from '@eureka/domains';
import { saveToProjectModule } from '@eureka/shared/save-to-project/services';
import { selectLlmModule } from '@eureka/shared/select-llm/services';
import { shareModule } from '@eureka/shared/share-tools/logic';
import { Container } from '@patsnap/tahiti-core/shared/inversify';

const container = new Container({
    defaultScope: 'Singleton',
    skipBaseClassChecks: true,
});

container.load(
    baseModule,
    headerServiceModule,
    sharedContainer,
    seekContainer,
    onboardingContainer,
    searchResultContainer,
    companyContainer,
    chatContainer,
    aiSearchContainer,
    monitorSuggestContainer,
    shareModule,
    biTrackModule,
    materialContainer,
    roadmapContainer,
    agentContainer,
    homeContainer,
    saveToProjectModule,
    selectLlmModule,
    projectContainer,
    ipServiceContainer
);

export {
    container,
};
